export type IssueStatus = 'open' | 'in_progress' | 'done'

export type IssueUrgency = 'low' | 'normal' | 'high' | 'urgent'

export interface IssueAccount {
  account: string
  name: string
  email: string
  phone: string
  status: IssueStatus
  note: string
  added_at?: string
  confirmed_at?: string | null
  confirmed_by?: string
}

export type WaitingState = 'none' | 'aryeh' | 'support'

export interface IssueReply {
  _id: string
  by_role: 'admin' | 'client'
  by_admin: string // admin username
  by_admin_id: string // admin id (to check authorship)
  text: string
  attachments: IssueAttachment[]
  date: string
}

export interface AdminOption {
  _id: string
  username: string
  departments?: string[]
}

// Department vocabulary — must match AdminUser.departments and the tickets
// module's DEPARTMENTS so the assignee dropdown can filter staff by department.
export const ISSUE_DEPARTMENTS = [
  {value: 'customer_service', label: 'שירות לקוחות'},
  {value: 'development', label: 'תמיכה טכנית'},
  {value: 'accounting', label: 'חשבונות'},
  {value: 'sales', label: 'מכירות'},
]

export interface IssueAttachment {
  url: string
  name: string
  type: string
}

export interface AccountIssue {
  _id: string
  title: string
  description: string
  status: IssueStatus
  urgency: IssueUrgency
  completed_at?: string | null
  fixed_confirmed_at?: string | null
  fixed_confirmed_by?: string // username of the admin who confirmed the fix
  created_by: 'admin' | 'client'
  opened_by: string // username of the admin who opened it
  waiting: WaitingState
  assigned_to: AdminOption | null
  department?: string | null
  due_date?: string | null // 'YYYY-MM-DD' — the calendar day the task is set for
  attachments: IssueAttachment[]
  accounts: IssueAccount[]
  replies: IssueReply[]
  created_at: string
  updated_at: string
}

export interface IssuesResponse {
  issues: AccountIssue[]
  open_count: number
}

// Minimal account shape returned by /admin/search-accounts (light mode).
export interface AccountSearchResult {
  _id: string
  first_name: string
  last_name: string
  email: string
}
